<template>
  <div>
    <surveys-table
      surveyName="UCT"
      surveyCode="UCT"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_UCT,
        viewDetail: permissions.SEE_DETAIL_SURVEY_UCT,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
